import { gql } from '@apollo/client'

export const UPDATE_STORE_PREPARATION_TIME = gql`
  mutation updateStorePreparationTime(
    $storeId: uuid!
    $params: UpdateStoreParams!
  ) {
    updateStore(storeId: $storeId, params: $params) {
      dynamicPreparationTimeBands {
        lowerThreshold
        upperThreshold
        extraMinutes
      }
    }
  }
`
